export default __webpack_public_path__ + "static/npr-0414703d83a6d65001644d8b81ac2261.svg";